import { useNavigate } from "react-router-dom";
import { PlusCircle, ShieldCheck, CalendarDays, Heart, AlertTriangle } from "lucide-react";

const ACTIONS = [
  { key: "create-session", label: "Create Session", to: "/admin/sessions", icon: PlusCircle },
  { key: "review-photographers", label: "Review Photographers", to: "/admin/verification", icon: ShieldCheck },
  { key: "view-upcoming", label: "View Upcoming Sessions", to: "/admin/sessions", icon: CalendarDays },
  { key: "review-matching", label: "Review Matching", to: "/admin/matches", icon: Heart },
  { key: "view-safety", label: "View Safety Reports", to: "/admin/safety", icon: AlertTriangle },
];

export const QuickActions = () => {
  const navigate = useNavigate();
  return (
    <div className="flex flex-wrap gap-3" data-testid="quick-actions">
      {ACTIONS.map(({ key, label, to, icon: Icon }) => (
        <button
          key={key}
          data-testid={`quick-action-${key}`}
          onClick={() => navigate(to)}
          className="flex items-center gap-2 px-4 py-2.5 rounded-full border-2 border-soft-gray hover:border-stranger-orange hover:text-stranger-orange transition-colors text-xs font-bold uppercase tracking-wide"
        >
          <Icon className="w-3.5 h-3.5" /> {label}
        </button>
      ))}
    </div>
  );
};
